jQuery( function($){

    $('.js-zoom-image').each(function(){
        var $this = $(this);
        var $image = $this.find('.js-zoom-image__image');
        var originalImagePath = $this.find('img').data('original-image');

        $image.zoom({
            url: originalImagePath,
            magnify: 1
        });

        // BOTÓN Y VELO IMAGE
        var $img = $this.find('.js-zoom-image__img');
        // var $velo = $this.find('.js-zoom-image__velo');
        var $btn = $this.find('.js-zoom-image__btn');
        var $icon = $btn.find('i');
        var $body = $('body');



        $btn.on('click', function (e) {
            e.stopPropagation();
            var $zoomImg = $this.find('.zoomImg');
            console.log($zoomImg);

            $img.toggleClass('invisible');
            // $velo.toggleClass('d-none');
            $zoomImg.toggleClass('visible');
            $icon.toggleClass('fa-search-plus').toggleClass('fa-search-minus');
        });

        $body.on('click', function () {
            var $zoomImg = $this.find('.zoomImg');

            $img.removeClass('invisible');
            // $velo.removeClass('d-none');
            $zoomImg.removeClass('visible');
            $icon.removeClass('fa-search-minus').addClass('fa-search-plus');
        });

        //
       /* $image.hover(
            function () { $img.addClass('d-none'); },
            function () { $image.removeClass('d-none'); }
        );*/
    });

});
